import PropTypes from 'prop-types'

const pgsseIndicator = PropTypes.shape({
    idIndicator: PropTypes.idIndicator, // Option[Long] = None,
    name: PropTypes.name, // Option[String] = None,
    description: PropTypes.description, // Option[String] = None,
    order: PropTypes.order, // Option[Int] = None,
    updateDate: PropTypes.updateDate, // Option[DateTime] = None,
    updateLogin: PropTypes.updateLogin, // Option[String] = None,
})

const pgsseIndicatorValue = PropTypes.shape({
    idDiagnostic: PropTypes.number, // Option[Long] = None,
    idIndicator: PropTypes.number, // Option[Long] = None,
    month: PropTypes.number, // Option[DateTime] = None,
    value: PropTypes.number, // Option[BigDecimal] = None,
    updateDate: PropTypes.number, // Option[DateTime] = None,
    updateLogin: PropTypes.string, // Option[String] = None,
    idOperator: PropTypes.number, // Option[Long] = None,
})

export { pgsseIndicator, pgsseIndicatorValue }
